import React, { useCallback, useState } from "react"
import { CabecalhoLogo } from "../cabecalho-logo/CabecalhoLogo"
const estilosCaixaDialogoPadrao = require('../../estilos/caixa-dialogo-padrao.module.scss').default
const estilosInputs = require('../../estilos/inputs.module.scss').default
const estilosFormulario = require('../../estilos/formulario.module.scss').default
import clsx from 'clsx'
const estilosBotoes = require('../../estilos/botoes.module.scss').default
import * as R from 'ramda'
import { BotaoAlternarTema } from "../tema/BotaoAlternarTema"

declare var window: any

export type LoginProps = {
    onLogin: (usuario: string, senha: string) => void
    executandoLogin: boolean
}

export const Login = (props: LoginProps) => {

    const [usuario, setUsuario] = useState("")
    const [senha, setSenha] = useState("")
    const [isCapsLockOn, setIsCapsLockOn] = useState(false)

    const checkCapsLock = useCallback((event) => {
            if (event && typeof event.getModifierState === 'function') {
                setIsCapsLockOn(event.getModifierState('CapsLock'));
                }
    }, [])

    return <>
        <div className={clsx(estilosCaixaDialogoPadrao.container, estilosCaixaDialogoPadrao.caixaFlutuante)} style={{ marginLeft: "auto", marginRight: "auto" }}
            id="Login_CaixaDialogo"
        >
            <CabecalhoLogo urlLogo={null} />

            <div className={estilosCaixaDialogoPadrao.corpo}
                id="Login_Corpo"
            >
                <div className={estilosFormulario.formularioCentralizado}
                    id="Login_Formulario"
                >
                    
                        {/* Input escondido para enganar o Chrome  para nao pedir para gravar senha */}
                        <input 
                            type="text" 
                            name="fakeUsername" 
                            style={{ display: 'none' }}
                        />
                        <input 
                            type="password" 
                            name="fakePassword" 
                            style={{ display: 'none' }}
                        />
                        {/* FIM- Input escondido para enganar o Chrome */}



                    <label>Usuário</label>
                    <input value={(usuario) ?? ""}
                        className={estilosInputs.inputPadrao}
                        id="Login_Usuario"
                        disabled={props.executandoLogin}
                        autoFocus
                        autoComplete="off"
                        aria-autocomplete="none"
                        list="autocompleteOff" // para naos mostrar dados digitados anteriormente
                        onChange={e => setUsuario(e.target.value)}
                        onKeyUp={checkCapsLock}
                        onFocus={checkCapsLock}
                        onKeyDown={e => {
                            if (R.includes(e.code, ["Enter", "NumpadEnter"])) {
                                props.onLogin(usuario, senha)
                            }
                        }} />

                    <label>Senha</label>
                    <input
                        value={(senha) ?? ""}
                        className={estilosInputs.inputPadrao}
                        disabled={props.executandoLogin}
                        autoComplete="new-password" // impede o Chrome de oferecer gravar/preencher a senha, sem depender de truque de type
                        aria-autocomplete="none"
                        list="autocompleteOff" // para naos mostrar dados digitados anteriormente
                        id="Login_Senha"
                        onChange={e => setSenha(e.target.value)}
                        type="password"
                        name="data-password"
                        onFocus={checkCapsLock}
                        onKeyUp={checkCapsLock}
                        onKeyDown={e => {
                            if (R.includes(e.code, ["Enter", "NumpadEnter"])) {
                                props.onLogin(usuario, senha)
                            }
                        }} 
                    />

                    <div></div>
                    <button className={estilosBotoes.botaoPrimario}
                        id="Login_BotaoEntrar"
                        disabled={props.executandoLogin || (senha?.length === 0 && usuario?.length === 0)}  
                        onFocus={()=> setIsCapsLockOn(false)}
                        style={{ width: 75 }}
                        onClick={() => props.onLogin(usuario, senha)}>{props.executandoLogin ? "Aguarde..." : "Entrar"}
                    </button>
                    
                </div>
            </div>
            {isCapsLockOn && (
                        <span className={estilosFormulario.formularioCentralizado} style={{color:"red",fontWeight:"bold", }}>CapsLock está ativado</span>
                    )}

        </div>

        {/* Escolha do tema já na tela de login, no canto inferior esquerdo da
            janela. A preferência é gravada em localStorage e reaplicada em todas
            as telas nos próximos acessos (ver app/tema.ts e o script inline no
            <head> de Views/Login/Index.cshtml).
            `position: fixed` porque o card do login é centralizado por flex — o
            botão precisa sair desse fluxo para ficar preso no canto da tela.

            `destacarQuandoSemPreferencia`: enquanto o usuário nunca escolheu um
            tema (nada em localStorage — vale o tema do sistema operacional), o
            botão pulsa para ser notado, já que é novidade na tela. Para no
            primeiro clique e não volta mais (ver BotaoAlternarTema/tema.ts). */}
        <div style={{ position: "fixed", bottom: 10, left: 14, zIndex: 10 }}
            id="Login_BotaoAlternarTema_Container"
        >
            <BotaoAlternarTema 
                id="Login_BotaoAlternarTema" 
                comRotulo 
                destacarQuandoSemPreferencia 
            />
        </div>

    </>
}

